<template>
    <v-content>
      <v-container fluid>
        <h1 class="py-3">Project Groups</h1>
        <v-alert v-if="error" :value="true" type="error">
          {{ error }}
        </v-alert>
        <ListTable :parentID="parentID" v-on:error="errorHandler" />
      </v-container>
    </v-content>
</template>

<script>
import ListTable from './ListTable'
export default {
  name: 'ProjectGroupList',
  components: { ListTable },
  data () {
    return {
      error: false,
      parentID: null
    }
  },
  methods: {
    errorHandler (error) {
      this.error = error
    }
  },
  beforeMount () {
    if (this.$route.query.parentid) {
      this.parentID = this.$route.query.parentid
    }
  }
}
</script>
